import {
  actionToIntlTitle,
  EPermissionGrantActions,
  EPermissionGrantSubjects,
  subjectToIntlTitle,
} from './permissions.type'
import { useTranslation } from 'react-i18next'

export function InsufficientPermission({
  subject,
  action,
}: {
  subject: EPermissionGrantSubjects
  action: EPermissionGrantActions
}) {
  const { t } = useTranslation()
  return (
    <div className="c-flex c-items-center c-justify-center c-flex-col">
      <h3 className={'c-font-extrabold c-text-red-500'}>
        {t('components.permission-error-report.insufficient-permissions')}
      </h3>
      <h3>
        {t('components.permission-error-report.permission-required')}{' '}
        <span className="c-font-extrabold">
          {t(actionToIntlTitle[action])} {t(subjectToIntlTitle[subject])}
        </span>
      </h3>
      <p>{t('components.permission-error-report.ask-your-administrator-for-permission-change')}</p>
      <img className="c-max-h-[450px] c-h-1/2 c-object-contain" src="/assets/img/no-permission.svg" alt="" />
    </div>
  )
}
